/**
 * useUpdateTransaction Hook
 *
 * 거래 수정 Hook
 * - 공유 transactionRepository 싱글톤 사용
 * - 로딩/에러 상태 관리
 *
 * @why 매 렌더링마다 new로 인스턴스를 만들지 않고 '../repositories' 싱글톤을
 * 사용해 메모리 누수 방지 + 테스트 가능성 확보.
 */

import { useState } from 'react'
import type { TransactionInput } from '../types/Transaction'
import { transactionRepository } from '../repositories'

export function useUpdateTransaction() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const updateTransaction = async (id: string, input: Partial<TransactionInput>) => {
    setLoading(true)
    setError(null)

    try {
      const updatedTransaction = await transactionRepository.update(id, input)
      return updatedTransaction
    } catch (err) {
      const message = err instanceof Error ? err.message : '거래 수정에 실패했습니다'
      setError(message)
      throw err
    } finally {
      setLoading(false)
    }
  }

  return {
    updateTransaction,
    loading,
    error,
  }
}
